var map = {
	"./decidim/participatory_processes/decidim_participatory_processes.svg": "../decidim-participatory_processes/app/packs/images/decidim/participatory_processes/decidim_participatory_processes.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../decidim-participatory_processes/app/packs/images sync recursive ^\\.\\/.*$";